// Returns the supermarket name, or a placeholder when the id is not in the list
// (e.g. the list failed to load or the option points to an unknown supermarket).
// The name is shown to tell apart options with the same name across supermarkets,
// so a visible placeholder is better than an empty label.
const getSupermarketName = (supermarkets, supermarketId) => {
  const supermarket = supermarkets.find((sup) => sup.id === supermarketId);
  return supermarket ? supermarket.name : 'sin supermercado';
};

export default getSupermarketName;
